type Product = {
  role?: string;
  applicationCode?: string;
  requiredPermission?: {
    application: string;
    feature: string;
    category: string;
  };
};

export function filterAccessibleProducts<T extends Product>(
  products: T[],
  canAccessSuperAdmin: boolean,
  hasPermission?: (application: string, feature: string, category: string) => boolean,
): T[] {
  return products.filter((product) => {
    if (product.role === "SuperAdmin" && !canAccessSuperAdmin) return false;
    const required = product.requiredPermission;
    return !required || Boolean(hasPermission?.(required.application, required.feature, required.category));
  });
}
